export default "__VITE_PUBLIC_ASSET__018b644a__"